<proffeo-ui-detail-panel
  (panelClosed)="closeRequested.emit()"
  [ariaLabel]="'task-details-panel.aria-label' | translate"
  [closeAriaLabel]="'task-details-panel.close' | translate"
  [showClose]="true"
  class="min-h-0 w-full flex-1"
>
  <!-- Row 1 (panel header): type + number, context menu, close. Row 2 (metadata slot): title. -->
  <div
    panelTitle
    class="min-w-0"
  >
    <proffeo-task-details-header
      (taskTypeSelected)="taskTypeSelected.emit($event)"
      [isMobile]="false"
      [isNameEditing]="isNameEditing()"
      [maxTaskNameLength]="maxTaskNameLength()"
      [taskActionsMenu]="taskActionsMenu()"
      [taskTypes]="taskTypes()"
      [task]="task()"
      desktopSection="identity"
      class="flex items-center"
    />
  </div>

  <div
    panelHeaderActions
    class="flex shrink-0 items-center gap-2"
  >
    <proffeo-task-details-view-settings />
    @if (showReopenActivity()) {
      <proffeo-ui-button
        (clicked)="activityReopenRequested.emit()"
        [ariaLabel]="'task-details-panel.reopen-activity' | translate"
        [tooltip]="'task-details-panel.reopen-activity' | translate"
        variant="ghost"
        fontIcon="forum"
      />
    }
    <div
      [matMenuTriggerFor]="taskActionsMenu()"
      class="inline-flex shrink-0"
    >
      <proffeo-ui-button
        [ariaLabel]="'project-tasks.list.task.open-actions' | translate"
        [tooltip]="'project-tasks.list.task.open-actions' | translate"
        variant="ghost"
        fontIcon="more_vert"
      />
    </div>
  </div>

  <div
    panelMetadata
    class="min-w-0"
  >
    <proffeo-task-details-header
      (nameEditCancelled)="nameEditCancelled.emit()"
      (nameEditRequested)="nameEditRequested.emit()"
      (taskNameChanged)="taskNameChanged.emit($event)"
      [isMobile]="false"
      [isNameEditing]="isNameEditing()"
      [maxTaskNameLength]="maxTaskNameLength()"
      [taskActionsMenu]="taskActionsMenu()"
      [taskTypes]="taskTypes()"
      [task]="task()"
      desktopSection="title"
    />
  </div>

  <div class="flex w-full min-w-0 flex-col gap-2">
    <proffeo-task-details-metadata-panel
      (openTimeReportRequested)="timeReportRequested.emit($event)"
      (timeReportsTabRequested)="timeReportsTabRequested.emit()"
      [layout]="'compact'"
      [task]="task()"
    />

    <div class="task-details-tabs-surface">
      <nav
        [tabPanel]="desktopTaskTabPanel"
        [disablePagination]="false"
        [mat-stretch-tabs]="false"
        mat-tab-nav-bar
        class="task-details-tabs w-full"
      >
        @for (tab of taskTabs; track tab.index) {
          <a
            (click)="onTabClick(tab.index, $event)"
            [active]="currentTabIndex() === tab.index"
            mat-tab-link
          >
            <span class="flex items-center gap-1.5">
              <mat-icon
                [fontIcon]="tab.icon"
                class="icon-md"
              />
              <span class="text-nowrap">{{ tab.labelKey | translate }}</span>
            </span>
          </a>
        }
      </nav>
    </div>

    <mat-tab-nav-panel #desktopTaskTabPanel>
      <ng-container *ngTemplateOutlet="tabContent()" />
    </mat-tab-nav-panel>
  </div>
</proffeo-ui-detail-panel>

<div class="w-full shrink-0">
  <ng-container *ngTemplateOutlet="subtasksContent()" />
</div>
